module.exports = __webpack_public_path__ + "img/ind_report_qrcode.f0324c1c.png";